import * as React from 'react';
import './AccountSummary.scss';
import LocaleFormating from 'src/translation/localeFormating';

export interface IToolBarProps {
  beginningBalance: number;
  payments: number;
  adjustments: number;
  chargesCredits: number;
  endingBalance: number;
  t?: any;
}

let t: any;

const numberFormat = (value: number) => {
  return value
    ? LocaleFormating.formatCurrency(parseFloat(value.toString()))
    : LocaleFormating.formatCurrency(0.0);
};

const renderHeader = (header: string) => {
  if (header === 'Ending balance') {
    return (
      <p
        className={`rp-ms-account-summary--header-title rp-ms-account-summary--header-balance`}
      >
        {header}
      </p>
    );
  }
  return <p className={`rp-ms-account-summary--header-title`}>{header}</p>;
};

const renderTotals = (value: string) => {
  return <p className={`rp-ms-account-summary--info-data`}>{value}</p>;
};

const AccountSummaryMobile: React.SFC<any> = props => {
  const {
    beginningBalance,
    payments,
    adjustments,
    chargesCredits,
    endingBalance
  } = props;
  return (
    <div className="rp-account-summary-mobile-container">
      <span className="rp-account-summary-mobile-title">
        {t('accountMonthlyStatements.accountSummaryTitle')}
      </span>
      <div className="rp-account-summary-mobile-info-container">
        <div className="rp-account-summary-info">
          <p className="rp-account-summary-info-title">
            {t('accountMonthlyStatements.begginingBalance')}
          </p>
          {beginningBalance && (
            <p className="rp-account-summary-info-data">{beginningBalance}</p>
          )}
        </div>
        <div className="rp-account-summary-info">
          <p className="rp-account-summary-info-title">
            - {t('accountMonthlyStatements.payments')}
          </p>
          {payments && (
            <p className="rp-account-summary-info-data">{payments}</p>
          )}
        </div>
        <div className="rp-account-summary-info">
          <p className="rp-account-summary-info-title">
            +/- {t('accountMonthlyStatements.adjustments')}
          </p>
          {adjustments && (
            <p className="rp-account-summary-info-data">{adjustments}</p>
          )}
        </div>
        <div className="rp-account-summary-info">
          <p className="rp-account-summary-info-title">
            {t('accountMonthlyStatements.chargesOrCredits')}
          </p>
          {chargesCredits && (
            <p className="rp-account-summary-info-data">{chargesCredits}</p>
          )}
        </div>
        <div className="rp-account-summary-info">
          <p className="rp-account-summary-info-title">
            {t('accountMonthlyStatements.endingBalance')}
          </p>
          {endingBalance && (
            <p className="rp-account-summary-info-data">{endingBalance}</p>
          )}
        </div>
      </div>
    </div>
  );
};

const AccountSummary: React.SFC<any> = props => {
  const {
    beginningBalance,
    payments,
    adjustments,
    chargesCredits,
    endingBalance
  } = props;
  t = props.t;
  const headers: JSX.Element[] = [];
  const amounts: JSX.Element[] = [];
  const values = [
    {
      header: `${t('accountMonthlyStatements.begginingBalance')}`,
      value: numberFormat(beginningBalance)
    },
    {
      header: `- ${t('accountMonthlyStatements.payments')}`,
      value: numberFormat(payments)
    },
    {
      header: `+/- ${t('accountMonthlyStatements.adjustments')}`,
      value: numberFormat(adjustments)
    },
    {
      header: `${t('accountMonthlyStatements.chargesOrCredits')}`,
      value: numberFormat(chargesCredits)
    },
    {
      header: `${t('accountMonthlyStatements.endingBalance')}`,
      value: numberFormat(endingBalance)
    }
  ];
  values.map((item: { header: string; value: string }) => {
    headers.push(renderHeader(item.header));
    amounts.push(renderTotals(item.value));
  });
  return (
    <div className="rp-account-statement--account-summary-container">
      <div className="rp-account-statement--account-summary-container-desktop">
        <div className="rp-ms-account-summary-title">
          {t('accountMonthlyStatements.accountSummaryTitle')}
        </div>
        <div className="rp-ms-account-summary-header-container">{headers}</div>
        <div className="rp-ms-account-summary-info-container">{amounts}</div>
      </div>
      <div className="rp-account-statement--account-summary-container-mobile">
        <AccountSummaryMobile
          beginningBalance={numberFormat(beginningBalance)}
          payments={numberFormat(payments)}
          adjustments={numberFormat(adjustments)}
          chargesCredits={numberFormat(chargesCredits)}
          endingBalance={numberFormat(endingBalance)}
        />
      </div>
    </div>
  );
};

export default AccountSummary;
